import { type Post } from "@package/ui-gql/index-data-access";

export function getQrCodeLinkUi(
  baseUrlApi: string,
  post?: Post,
  location?: string,
  profile?: string,
): string | null {
  return `${baseUrlApi}/${location}/${profile}/${post?.id}`;
}

export function hasQrCodeLink(location: string, profile: string, post?: Post) {
  if (
    post?.qrCodeLinkByLocationProfile?.find(
      (q) => q?.location === location || q?.profile === profile,
    )?.qrCodeLink ??
    post?.qrCodeLink
  ) {
    return true;
  }

  return false;
}
